import React from "react";
import MainLogo from "../../../../../UI/MainLogo";

const LoginLogo = () => {
    return(
        <div>
            <MainLogo params="text-xl font-bold text-black"/>
        </div>
    );
}

export default LoginLogo;